import {ActionButton} from "@pl/pl-lib/common";
import {PlEntityListConfigurator} from "../pl-entity-list/pl-entity-list.configurator";
import {TreeListConfigurator} from "@pl/pl-lib/tree-lists";

export class PlEntityListPageConfigurator {
  title: string;
  actions?: ActionButton[];

  gridConfigurator: PlEntityListConfigurator | TreeListConfigurator;

}
